module.exports = __webpack_public_path__ + "static/img/RAC1610M_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAC1610M_1.png
// module id = Hy7h
// module chunks = 0